























































import { Vue, Component } from 'vue-property-decorator'
import { ActivityRankItem, ActivityRankSelf } from '@/modules/marketing/activity/types'
import { numberFormat, numberFormatWithUnit } from './config'

@Component({
  filters: {
    numberFormatWithUnit
  }
})
export default class ActivityRank extends Vue {
  selfDataConfig = [
    { key: 'num_view', label: '浏览次数' },
    { key: 'num_uv', label: '浏览人数' },
    { key: 'num_share', label: '分享' },
    { key: 'num_enroll', label: '报名' },
    { key: 'subtract', label: '比上一名少' }
  ]
  activityDataConfig = [
    { key: 'show_num_uv', label: '浏览人数' },
    { key: 'show_num_share', label: '分享' },
    { key: 'show_num_enroll', label: '报名', color: '#ff630b' }
  ]

  queryForm = {
    page: 1,
    count: 100,
    activity_id: 0
  }

  activityRankList: ActivityRankItem[] = []

  selfRank: ActivityRankSelf = {
    avatar: '',
    name: '',
    num_enroll: 0,
    ranking: 0,
    department: '',
    subtract: 0
  }

  mounted() {
    const { id = '0' } = this.$route.params
    this.queryForm.activity_id = +id
    this.getData()
    this.getSelfData()
  }

  async getData() {
    const { code, data } = await this.$rest.marketing.getActivityRankList({ ...this.queryForm })
    if (code === 0) {
      this.activityRankList = data.statistics.map((o: ActivityRankItem) => {
        return {
          ...o,
          show_num_uv: numberFormat(o.num_uv),
          show_num_enroll: numberFormat(o.num_enroll),
          show_num_share: numberFormat(o.num_share)
        }
      })
    }
  }

  async getSelfData() {
    const { code, data } = await this.$rest.marketing.getSelfActivityRank({ activity_id: this.queryForm.activity_id })
    if (code === 0) {
      this.selfRank = data
    }
  }
}
